import React from 'react';
import { AlertCircle, CheckCircle, Clock, FileText } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { formatCurrency } from '@/utils/currency';

export interface PaymentMetricsProps {
  totalDue: number;
  paidThisMonth: number;
  pendingApprovals: number;
  missingInvoices: number;
}

export const PaymentMetrics: React.FC<PaymentMetricsProps> = ({
  totalDue,
  paidThisMonth,
  pendingApprovals,
  missingInvoices,
}) => {
  const { userCountry } = useAuth();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white p-4 rounded-lg border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Total Due</p>
            <p className="text-2xl font-bold text-red-600">
              {formatCurrency(totalDue || 0, userCountry)}
            </p>
          </div>
          <AlertCircle className="w-8 h-8 text-red-500" />
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Paid This Month</p>
            <p className="text-2xl font-bold text-green-600">
              {formatCurrency(paidThisMonth || 0, userCountry)}
            </p>
          </div>
          <CheckCircle className="w-8 h-8 text-green-500" />
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Pending Approvals</p>
            <p className="text-2xl font-bold text-yellow-600">{pendingApprovals}</p>
          </div>
          <Clock className="w-8 h-8 text-yellow-500" />
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Missing Invoices</p>
            <p className="text-2xl font-bold text-orange-600">{missingInvoices}</p>
          </div>
          <FileText className="w-8 h-8 text-orange-500" />
        </div>
      </div>
    </div>
  );
};

export default PaymentMetrics;
